// extracted by mini-css-extract-plugin
export const heroSection = "my-plan-module--hero-section--3AF5c";
export const pageSection = "my-plan-module--page-section--1bUDt";